import React, { JSXElementConstructor, ReactElement } from "react";
import { SubscriptionFactoryStrategyStatementButton, SubscriptionStatement } from "../../interfaces";
import { StrategyStatementButtonCancelWaiting, StrategyStatementButtonChangePlan } from "../screens/components";

export class SubscriptionFactoryStrategyStatementButtonImpl implements SubscriptionFactoryStrategyStatementButton {
    createButton(subscription: SubscriptionStatement, isUpdateable: boolean): ReactElement<any, string | JSXElementConstructor<any>> {
        if (subscription.status === 'WAITING') return <StrategyStatementButtonCancelWaiting id={subscription.id} biStatus={subscription.bi_status} />
        if (!isUpdateable) return <></>
        if (subscription.status === 'ACTIVATED') return <StrategyStatementButtonChangePlan subscription={subscription} />
        return <></>;
    }
}